import React, { useEffect } from 'react';

export type ContentfulEmbedCodeProps = {
  embedCode: string;
  displayCode: 'Script' | 'Head' | 'Inline';
};

const ContentfulEmbedCode = ({ embedCode, displayCode }: ContentfulEmbedCodeProps) => {
  useEffect(() => {
    if (displayCode === 'Script') {
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.innerHTML = embedCode;
      document.body.appendChild(script);
    }
    if (displayCode === 'Head') {
      const template = document.createElement('template');
      template.innerHTML = embedCode.trim();
      const element = template.content.firstChild;
      document.head.appendChild(element);
    }
  }, []);

  if (displayCode === 'Inline') {
    return <div dangerouslySetInnerHTML={{ __html: embedCode }} />;
  }

  return null;
};

export default ContentfulEmbedCode;
